// Module
var code = `<div class="cs-row">
  <div class="cs-label">
    <i class="icon-group"></i>
    <span class="cs-label-text">{{\$ctrl.labels.demographicData}}</span>
  </div>
  <div class="cs-value" ng-class="\$ctrl.getScoreColorLabel(\$ctrl.score.demographicData)">
    {{\$ctrl.getScoreColor(\$ctrl.score.demographicData)}}
  </div>
</div>
<div class="cs-row">
  <div class="cs-label">
    <i class="icon-credit-card"></i>
    <span class="cs-label-text">{{\$ctrl.labels.creditHistory}}</span>
  </div>
  <div class="cs-value" ng-class="\$ctrl.getScoreColorLabel(\$ctrl.score.creditHistory)">
    {{\$ctrl.getScoreColor(\$ctrl.score.creditHistory)}}
  </div>
</div>
<div class="cs-row">
  <div class="cs-label">
    <i class="icon-dollar"></i>
    <span class="cs-label-text">{{\$ctrl.labels.accountsHistory}}</span>
  </div>
  <div class="cs-value" ng-class="\$ctrl.getScoreColorLabel(\$ctrl.score.accountsHistory)">
    {{\$ctrl.getScoreColor(\$ctrl.score.accountsHistory)}}
  </div>
</div>
<div class="cs-row">
  <div class="cs-label">
    <i class="icon-list-ul"></i>
    <span class="cs-label-text">{{\$ctrl.labels.loanApplicationData}}</span>
  </div>
  <div class="cs-value" ng-class="\$ctrl.getScoreColorLabel(\$ctrl.score.loanApplicationData)">
    {{\$ctrl.getScoreColor(\$ctrl.score.loanApplicationData)}}
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-legend.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;